import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class CatologosGenericosService {

    endPonit: string = 'https://a-catalogos-publicos.sefintlax.gob.mx/CatalogosPublicos/catalogosINEGI'

    constructor(private http: HttpClient) {

    }

    /** METODO QUE CONSUME EL SERVICIO DE TIPO POST */
    postQuery(query: string, url: string) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.post(url, query, { headers });
    }


    /** METODO QUE CONSUME EL SERVICIO DE TIPO GET */
    getQuery(query: string, url: string) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.get(url + '' + query, { headers });
    }

    getLocalidades(codigoPostal: string) {
        let url = `${this.endPonit}/catCodigoPostal?codigoPostal=${codigoPostal}`;
        //const parametrosOut = JSON.stringify({ "codigoPostal": parseInt(codigoPostal)});
       //console.log(url);
        return this.getQuery('',url).pipe(map((data: any) => data));
    }

}
